import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const GPSTracker = ({ user, vehicleId = null }) => {
  const [isTracking, setIsTracking] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const watchIdRef = useRef(null);

  useEffect(() => {
    // Auto-start tracking for drivers
    if (user && user.role === 'driver') {
      startTracking();
    }

    return () => {
      stopTracking();
    };
  }, [user]);

  const startTracking = () => {
    if (!navigator.geolocation) {
      toast.error('GPS nicht verfügbar');
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    };

    watchIdRef.current = navigator.geolocation.watchPosition(
      (position) => {
        sendLocation(position);
      },
      (error) => {
        console.error('GPS Error:', error);
        // Don't show error toast on every fail, just log it
      },
      options
    );

    setIsTracking(true);
  };

  const stopTracking = () => {
    if (watchIdRef.current) {
      navigator.geolocation.clearWatch(watchIdRef.current);
      watchIdRef.current = null;
      setIsTracking(false);
    }
  };

  const sendLocation = async (position) => {
    try {
      const locationData = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
        speed: position.coords.speed,
        heading: position.coords.heading,
        vehicle_id: vehicleId
      };

      await axios.post('/gps/update', locationData);
      setLastUpdate(new Date());
    } catch (error) {
      console.error('Error sending location:', error);
    }
  };

  // Don't render anything (background service)
  return null;
};

export default GPSTracker;
